module.exports = __webpack_public_path__ + "static/media/flooring_allImpact_10y_n.1f0c54cc.csv";